import { TileLayer } from '@deck.gl/geo-layers';
import { parse } from '@loaders.gl/core';

import { geoBbox } from './tileBbox';
import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

export const eagriLayer = () =>
  new TileLayer({
    id: 'eagri-aerial-layer',
    getTileData: async ({ index: { x, y, z }, bbox }) => {
      const { east, south, north, west } = geoBbox(bbox);
      const url = `https://mze.gov.cz/public/app/lpisext/lpis/mapserver64/cgi-bin/iop_rastry_lpis.fcgi?LAYERS=ORTOFOTO&TRANSPARENT=FALSE&FORMAT=image%2Fjpeg&SERVICE=WMS&VERSION=1.1.1&REQUEST=GetMap&STYLES=&SRS=EPSG%3A5514&_OLSALT=0.951789307869803&WIDTH=256&HEIGHT=256&SRS=EPSG%3A4326&BBOX=${west},${south},${east},${north}`;
      const result = await fetch(url);
      const data = await parse(result);
      return data;
    },
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });
